import { render, staticRenderFns } from "./add-partner.vue?vue&type=template&id=74c92ade&scoped=true&"
import script from "./add-partner.vue?vue&type=script&lang=js&"
export * from "./add-partner.vue?vue&type=script&lang=js&"
import style0 from "./add-partner.vue?vue&type=style&index=0&id=74c92ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c92ade",
  null
  
)

export default component.exports